import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UkExchangeRates')
export class UkExchangeRates {
  @JsonProperty('monthYear', String, false) monthYear: string = undefined;
  @JsonProperty('exchangeRate', Number, false) exchangeRate: number = undefined;
}
